// 빌드: ./fe-build.sh youth
import 'es6-promise/auto'
import Vue from 'vue'
import Axios from 'axios'
import Pager from './components/common/pagingUser.vue';
import Common from './components/ynadmin/common/common.js';
import Datepicker from './components/ynadmin/common/datepicker.vue';
import Editor from "./components/common/editor.vue";
import swal from 'sweetalert';
import Validator from './components/common/validation.js';
import validation from 'validator';
import VueFileAgent from 'vue-file-agent';
import 'vue-file-agent/dist/vue-file-agent.css';
import 'vue2-datepicker/index.css';
import KProgress from 'k-progress';
import Share from './components/common/share.js';

Vue.use(VueFileAgent);

import DropImg from "./components/common/dragImgFile.vue";
import DropDoc from "./components/common/dragDocFile.vue";
import DropVideo from "./components/common/dragVideoFile.vue";

Vue.component("pager", Pager);
Vue.component('common', Common);
Vue.component('editor', Editor);
Vue.component('star-rating', VueStarRating.default);
Vue.component('dropimg', DropImg);
Vue.component('dropdoc', DropDoc);
Vue.component('dropvideo', DropVideo);
Vue.component('k-progress', KProgress);

Vue.prototype.$pager = Pager;
Vue.prototype.$datepicker = Datepicker;

new Vue({
  el: '#youth',
  data: function () {
    return {
      mainName: '청소년 NEWS',
      isShare: false,
      listBanner: [''],
      searchModel: {
        brdSubCtg: '',
        searchKeyword: '',   //뉴스검색어
        searchOrder: '1'    //최신순,인기순 정렬
      },
      insertNewsModel: {
        brdUidKey: '',
        gubun: 'reporter_award', //대한민국청소년기자대상
        kind: 'post',
        title: '',
        content1: '',
        content2: '', //기사내용 요약(주제)
        content3: '', //기사주제 선정이유
        staff: '',
        staffCnt: 0,
        support: '', //타 기관 및 전문가 지원여부
        way: 'NEWSWAYNV00110', //지원경로 - 학교공문
        wayEtc: '',
        history: '',
        team: '',
        videoLink: '',
        link: '',
        usrKey: ''
      },
      insertNewsReply: {
        replyUidKey: '',
        replyRating: 0,
        replyName: '',
        replyPassword: '',
        replyContent: '',
        usrKey: ''
      },
      updateNewsReply: {
        replyUidKey: '',
        replyRating: 0,
        replyName: '',
        replyPassword: '',
        replyContent: '',
        usrKey: ''
      },
      insertNewsReReply: {
        replyUidKey: '',
        replyName: '',
        replyPassword: '',
        replyContent: ''
      },
      updateNewsReReply: {
        replyUidKey: '',
        replyName: '',
        replyPassword: '',
        replyContent: ''
      },
      insertNewsReport: {
        reportValue: '',
        reportEtcValue: ''
      },
      viewModel: {
        pager: {
          model: {},
          pageNo: 1,
          pageNum: 1,
          totalSize: 0,
          rowSize: 10,
          blockSize: 5,
          endSize: 0,
          list: [],
          href: "javascript:void(0)",
          etc: '',
          callBack: function (n) {
            let _etc = this.model.viewModel.pager.etc;
            if (_etc == 'selectYouthBoardList') {
              this.model.fnGetYouthNewsList(null, n);
            } else if (_etc == 'selectYouthReplyList') {
              this.model.fnGetYouthReplyList(n);
            }
          }
        },
        isReply: false,
        isReplyPwd: false,
        isReplyUpt: false,
        isReReply: false,
        isReReplyUpt: false,
        isReport: false,
        isLike: false,
        agree1: false,
        agree2: false,
        currReplyUidKey: '',
        replyUptDelFlag: '',
        inputPwd: '',
        totalCount: 1,
        detail: {},
        userDetail: {},
        youthBoardList: [],
        reportCodeList: [],
        reportList: [],
        replyList: [],
        replyDepthZero: [],
        replyDepthOne: [],
        codeList: [],
        fileEtcList: [],
        fileImgList: [],
        fileVdList: []
      }
    }
  },
  created: function () {
    if (!('$' in Vue.prototype) && '$' in window) {
      Vue.prototype.$ = window.$;
    }
  },
  mounted: function () {
    try {
      pageLoad(this);
    } catch (e) {
      console.log(e);
    }
  },
  methods: {
    fnGoYouthNewsMain: function () { //청소년뉴스 메인 페이지
      location.href = '/customer/youth';
    },
    fnGoYouthNewsDetail: function (uid) { //기사 상세보기 페이지
      let vm = this;

      let order = vm.searchModel.searchOrder;

      let pageNum = vm.viewModel.pager.pageNo;

      sessionStorage.setItem("URL", "/customer/youth?order=" + order + "&pageNum=" + pageNum);


      location.href = '/customer/youth/youthNewsDetail?paramUid=' + uid;
    },
    fnGoYouthNewsInsertMain: function () { //기사 작성 페이지
      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      } else if ($("#usrSmlCode").val() !== 'USRNVYTHNV00110') { // 청소년(USRNVYTHNV00110)이 아닌 경우
        return swal("청소년만 작성이 가능합니다.")
      } else {
        location.href = '/customer/youth/youthNewsInsertMain?paramUid=';
      }
    },
    fnGoYouthNewsUpdate: function (uid) { //기사 작성 수정 페이지
      location.href = '/customer/youth/youthNewsInsertMain?paramUid=' + uid;
    },

    // 배너 조회
    fnGetYouthReportBanner: function () {
      const vm = this;
      let _param = {
        uidKey: 'BANNVLOCNV00700',
        divide: 'custommer'
      }
      let param = {
        pageNo: 0,
        pageSize: 10,
        paramText: JSON.stringify(_param)
      };

      Axios.post("/api/admin/banner/list", param).then(function (response) {
        vm.listBanner = response.data.list;
        console.log('listBanner', vm.listBanner);
      }).catch(function (ex) {
        console.log(ex);
      });
    }

    /*============================================================ 조회 start ========================================================================*/,
    //코드 조회
    fnGetCodeList: function () {
      let vm = this;
      let param = {};
      param.searchCode = "NEWSWAY" //지원경로

      Axios.post("/customer/youth/selectCodeList", {youthVo: param}).then(function (response) {
        vm.viewModel.codeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 리스트 조회
    fnGetYouthNewsList: function (tabIdx, pageNumber) {
      let vm = this;
      vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;
      if (tabIdx) {
        vm.searchModel.searchOrder = tabIdx;
      }

      let pageNo = vm.viewModel.pager.pageNo;
      let pageSize = vm.viewModel.pager.rowSize;

      Axios.post("/customer/youth/selectYouthBoardList", {
        youthVo: vm.searchModel,
        pageNo: pageNo,
        pageSize: pageSize
      }).then(function (response) {
        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.youthBoardList = response.data.list;
        if (vm.viewModel.youthBoardList.length > 0) {
          vm.viewModel.youthBoardList.forEach(function (item) {
            item.content = vm.fnOnLoadKakaoContent(item.content1)
            if (item.prvsDat == 'Y') {
              console.log("item.prvsImg", item.prvsImg);
              item.imagePath = item.prvsImg;
            }
          });
        }
        vm.fnSetPager(vm.viewModel.totalCount, "selectYouthBoardList");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 상세조회
    fnGetYouthNewsDetail: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();

      Axios.post("/customer/youth/selectYouthNewsDetail", {youthVo: param}).then(function (response) {
        vm.viewModel.detail = response.data.youthVo;
        document.title = response.data.youthVo.title;

        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;
        vm.viewModel.fileVdList = response.data.fileVdList;

        vm.viewModel.fileEtcList.forEach(function (file) {
          file.fileUrl = "/doc/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileImgList.forEach(function (file) {
          file.fileUrl = "/img/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name;
        });
        vm.viewModel.fileVdList.forEach(function (file) {
          file.fileUrl = "/video/" + file.file_new_name.substr(0, 8) + "/" + file.file_new_name.split(".")[0] + ".mp4";
        });
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 수정 시 상세조회
    fnGetYouthNewsDetailUpt: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();

      Axios.post("/customer/youth/selectYouthNewsDetailUpt", {youthVo: param}).then(function (response) {
        vm.insertNewsModel = response.data.youthVo;
        vm.viewModel.fileEtcList = response.data.fileEtcList;
        vm.viewModel.fileImgList = response.data.fileImgList;
        vm.viewModel.fileVdList = response.data.fileVdList;

        // let oldFileKey = "";
        // vm.viewModel.fileImgList.forEach(function(file){
        //     oldFileKey = file.cmm_sprt;
        // });
        // vm.viewModel.fileVdList.forEach(function(file){
        //     oldFileKey = file.cmm_sprt;
        // });

        // if(oldFileKey != ""){
        //     $("#fileKey").val(oldFileKey);
        // }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 댓글리스트 조회
    fnGetYouthReplyList: function (pageNumber) {
      let vm = this;
      //vm.viewModel.pager.pageNo = pageNumber ? pageNumber : 1;

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      // param.pageNo = vm.viewModel.pager.pageNo;
      // param.pageSize = vm.viewModel.pager.rowSize;

      Axios.post("/customer/youth/selectYouthReplyList", {youthVo: param}).then(function (response) {
        response.data.depthZeroList.forEach(function (reply) {
          if (reply.fileNewName != null) {
            reply.fileNewName = "/img/" + reply.fileNewName.substr(0, 8) + "/" + reply.fileNewName;
          }
        });

        response.data.depthOneList.forEach(function (reply) {
          if (reply.fileNewName != null) {
            reply.fileNewName = "/img/" + reply.fileNewName.substr(0, 8) + "/" + reply.fileNewName;
          }
        });

        vm.viewModel.totalCount = response.data.totalCount;
        vm.viewModel.replyDepthZero = response.data.depthZeroList;
        vm.viewModel.replyDepthOne = response.data.depthOneList;
        //vm.fnSetPager(vm.viewModel.totalCount, "selectYouthReplyList");
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //신고 사유 조회
    fnGetReportCodeList: function () {
      let vm = this;
      Axios.post("/customer/youth/selectReportCodeList", {youthVo: {}}).then(function (response) {
        vm.viewModel.reportCodeList = response.data.list;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 신고/좋아요 조회
    fnGetYouthReportList: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      Axios.post("/customer/youth/selectYouthReportList", {youthVo: param}).then(function (response) {
        vm.viewModel.reportList = response.data.list;

        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100" && report.likeYn == "Y") { //좋아요
              vm.viewModel.isLike = true;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 작성 시 사용자 정보 조회
    fnGetUserDetail: function () {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      Axios.post("/customer/youth/selectUserDetail", {youthVo: param}).then(function (response) {
        vm.viewModel.userDetail = response.data.youthVo;
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //댓글 수정/삭제 비밀번호 체크
    fnCheckPassword: function (youthVo) {
      let vm = this;
      let param = {};
      param.replyUidKey = youthVo.replyUidKey;
      param.replyPassword = vm.viewModel.inputPwd;

      Axios.post("/customer/youth/chkReplyPwd", {youthVo: param}).then(function (response) {
        if (response.data.totalCount == 1) {
          vm.viewModel.isReplyPwd = false;
          vm.viewModel.inputPwd = "";

          if (vm.viewModel.replyUptDelFlag == "upt") {
            vm.fnReplySetValue(youthVo);
          } else if (vm.viewModel.replyUptDelFlag == "del") {
            vm.fnDelReply(youthVo.replyUidKey);
          }
        } else {
          swal("비밀번호가 일치하지 않습니다.");
          return false;
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    /*============================================================ 조회 end ========================================================================*/

    /*============================================================ 저장 start ========================================================================*/,
    //기사 작성/수정
    fnSetYouthNews: function () {
      let vm = this;

      if ($("#usrKey").val() == null || $("#usrKey").val() == "") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      if (vm.insertNewsModel.staffCnt < 1) {
        swal("스태프 인원수를 확인해주세요.");
        return false;
      }

      if (validation.isEmpty(vm.insertNewsModel.staff)) {
        swal("스태프 역할을 입력해주세요.");
        return false;
      }

      // if(validation.isEmpty(vm.insertNewsModel.support.trim())){
      //     swal("기관 및 전문가 지원여부를 입력해주세요.");
      //     return false;
      // }

      if (validation.isEmpty(vm.insertNewsModel.title)) {
        swal("제목을 입력해주세요.");
        return false;
      }

      if (!validation.isLength(vm.insertNewsModel.title, 0, 200)) {
        swal("제목이 너무 깁니다.");
        return false;
      }

      if (validation.isEmpty(vm.insertNewsModel.team)) {
        swal("소속을 입력해주세요.");
        return false;
      }

      if (validation.isEmpty(vm.insertNewsModel.content2)) {
        swal("주제를 입력해주세요.");
        return false;
      }

      if (vm.$refs.dropimg.cnt == 0) {
        swal("대표이미지를 등록해주세요.");
        return false;
      }

      if (vm.insertNewsModel.kind == "post") {
        if (validation.isEmpty(vm.insertNewsModel.content1)) {
          swal("내용을 입력해주세요.");
          return false;
        }
      } else if (vm.insertNewsModel.kind == "movie") {
        if (vm.$refs.dropvideo.cnt == 0) {
          swal("영상을 등록해주세요.");
          return false;
        }
      }

      if (validation.isEmpty(vm.insertNewsModel.content3)) {
        swal("선정이유를 입력해주세요.");
        return false;
      }

      let param = {};
      param.usrKey = $("#usrKey").val();
      param.usrId = $("#usrId").val();
      param.fileKey = $("#fileKey").val();
      param.title = vm.insertNewsModel.title;
      param.content1 = vm.insertNewsModel.content1;
      param.content2 = vm.insertNewsModel.content2;
      param.content3 = vm.insertNewsModel.content3;
      param.staff = vm.insertNewsModel.staff;
      param.staffCnt = vm.insertNewsModel.staffCnt;
      param.support = vm.insertNewsModel.support;
      param.gubun = vm.insertNewsModel.gubun;
      param.kind = vm.insertNewsModel.kind;
      param.history = vm.insertNewsModel.history;
      param.team = vm.insertNewsModel.team;
      param.videoLink = vm.insertNewsModel.videoLink;
      param.link = vm.insertNewsModel.link;
      param.way = vm.insertNewsModel.way;
      if (vm.insertNewsModel.way == "NEWSWAYNV00160") { //기타
        param.wayEtc = vm.insertNewsModel.wayEtc;
      }

      let url = "";
      if ($("#paramUid").val() != "" && $("#paramUid").val() != null) {
        param.brdUidKey = $("#paramUid").val();
        url = "/customer/youth/updateYouthNews";
      } else {
        param.representYn = 'Y';
        url = "/customer/youth/insertYouthNews";
      }

      vm.fnOnSwalAlert("청소년 NEWS", "등록하시겠습니까?",
        function () {
          Axios.post(url, {youthVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '등록 완료',
                text: '등록이 완료되었습니다.',
                icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            } else if (response.data.succCnt == -999) {
              swal({
                title: '등록 실패',
                text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
                icon: vm.fnOnLoadSwalImageData('error'),
                buttons: {
                  cancel: {
                    text: "Cancel",
                    value: false,
                    visible: false,
                  },
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  return false;
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    },
    //기사 삭제
    fnDelYouthNews: function () {
      let vm = this;
      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();

      vm.fnOnSwalAlert("청소년 NEWS", "삭제하시겠습니까?",
        function () {
          Axios.post("/customer/youth/deleteYouthNews", {youthVo: param}).then(function (response) {
            if (response.data.succCnt > 0) {
              swal({
                title: '삭제 완료',
                text: '삭제가 완료되었습니다.',
                icon: vm.fnOnLoadSwalImageData('success'),
                buttons: {
                  confirm: {
                    text: "Ok",
                    value: true,
                    visible: true,
                  },
                },
                dangerMode: true
              }).then(result => {
                if (result) {
                  window.history.back();
                }
              });
            }
          }).catch(function (ex) {
            console.log(ex);
          });
        }
      );
    },
    //기사 댓글작성
    fnSetReply: function (_depth, replyUidKey) {
      let vm = this;
      let usrKey = $("#usrKey").val();

      //게스트
      if ($("#usrKey").val() == null || $("#usrKey").val() == "" || $("#usrKey").val() == "GUEST") {
        if (_depth == 0) {
          if (validation.isEmpty(vm.insertNewsReply.replyName)) {
            swal("이름을 입력해주세요.");
            return false;
          }
          if (validation.isEmpty(vm.insertNewsReply.replyPassword)) {
            swal("비밀번호를 입력해주세요.");
            return false;
          }
          if (validation.isEmpty(vm.insertNewsReply.replyContent)) {
            swal("내용을 입력해주세요.");
            return false;
          }
        } else if (_depth == 1) {
          if (validation.isEmpty(vm.insertNewsReReply.replyName)) {
            swal("이름을 입력해주세요.");
            return false;
          }
          if (validation.isEmpty(vm.insertNewsReReply.replyPassword)) {
            swal("비밀번호를 입력해주세요.");
            return false;
          }
          if (validation.isEmpty(vm.insertNewsReReply.replyContent)) {
            swal("내용을 입력해주세요.");
            return false;
          }
        }
      }

      let param = {};
      if (_depth == 0) {
        param.replyDepth = _depth;
        param.brdUidKey = $("#paramUid").val();
        param.replyContent = vm.insertNewsReply.replyContent;
        param.replyName = vm.insertNewsReply.replyName;
        param.replyPassword = vm.insertNewsReply.replyPassword;
        param.usrKey = usrKey ? usrKey : "GUEST"; //세션
        param.replyRating = vm.insertNewsReply.replyRating;
      } else if (_depth == 1) {
        param.replyDepth = _depth;
        param.brdUidKey = $("#paramUid").val();
        param.replyContent = vm.insertNewsReReply.replyContent;
        param.replyName = vm.insertNewsReReply.replyName;
        param.replyPassword = vm.insertNewsReReply.replyPassword;
        param.usrKey = usrKey ? usrKey : "GUEST"; //세션
        param.parentsUidKey = replyUidKey;
      }

      Axios.post("/customer/youth/insertReply", {youthVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.insertNewsReply.replyContent = "";
          vm.insertNewsReReply.replyContent = "";
          vm.fnClearReply();
          vm.fnGetYouthReplyList();
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "Cancel",
                value: false,
                visible: false,
              },
              confirm: {
                text: "Ok",
                value: true,
                visible: true,
              },
            },
            dangerMode: true
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 댓글 수정
    fnUptReply: function (_depth, replyUidKey) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      if (_depth == 0) {
        param.replyUidKey = replyUidKey;
        param.replyContent = vm.updateNewsReply.replyContent;
        param.replyRating = vm.updateNewsReply.replyRating;
      } else if (_depth == 1) {
        param.replyUidKey = replyUidKey;
        param.replyContent = vm.updateNewsReReply.replyContent;
      }

      Axios.post("/customer/youth/updateReply", {youthVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.updateNewsReply.replyContent = "";
          vm.updateNewsReReply.replyContent = "";
          vm.fnClearReply();
          vm.fnGetYouthReplyList();
        } else if (response.data.succCnt == -999) {
          swal({
            title: '등록 실패',
            text: '등록에 실패하였습니다(개인정보 또는 비속어 포함)',
            icon: vm.fnOnLoadSwalImageData('error'),
            buttons: {
              cancel: {
                text: "Cancel",
                value: false,
                visible: false,
              },
              confirm: {
                text: "Ok",
                value: true,
                visible: true,
              },
            },
            dangerMode: true
          }).then(result => {
            if (result) {
              return false;
            }
          });
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 댓글 삭제
    fnDelReply: function (replyUidKey) {
      let vm = this;
      let param = {};
      param.usrKey = $("#usrKey").val();
      param.replyUidKey = replyUidKey;

      if (!confirm("삭제하시겠습니까?")) {
        return false;
      }

      Axios.post("/customer/youth/deleteReply", {youthVo: param}).then(function (response) {
        if (response.data.succCnt > 0) {
          vm.fnGetYouthReplyList();
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    },
    //기사 추천/신고 하기
    fnSetReport: function (kind) {
      let vm = this;
      let url = "/customer/youth/insertRecommend";

      if ($("#usrKey").val() == null || $("#usrKey").val() == "" || $("#usrKey").val() == "GUEST") {
        swal("로그인 후 이용해주세요.").then(result => {
          location.href = '/youthnavi/signup/login';
        });
        return false;
      }

      if (kind == 'report') {
        let reportFlag = false;
        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00200") { //신고
              reportFlag = true;
            }
          });
        }
        if (reportFlag) {
          swal("이미 신고하셨습니다.");
          return false;
        } else {
          if (vm.insertNewsReport.reportValue == null || vm.insertNewsReport.reportValue == "") {
            swal("신고사유를 선택해주세요.");
            return false;
          }
        }
      } else if (kind == 'like') {
        if (vm.viewModel.detail.usrKey == $("#usrKey").val()) {
          swal("자신이 올린 글은 좋아요를 누를 수 없습니다.");
          vm.viewModel.isLike = false;
          return false;
        }
        if (vm.viewModel.reportList.length > 0) {
          vm.viewModel.reportList.forEach(function (report) {
            if (report.rcmmCate == "RCMNVYTHNV00100") { //좋아요
              url = "/customer/youth/updateYouthLike";
            }
          });
        }
      }

      let param = {};
      param.brdUidKey = $("#paramUid").val();
      param.usrKey = $("#usrKey").val();
      if (kind == 'like') {
        param.rcmmCate = "RCMNVYTHNV00100"; //RCMNVYTHNV00100 추천 / RCMNVYTHNV00200 신고
        param.likeYn = 'Y';
      } else if (kind == 'report') {
        param.rcmmCate = "RCMNVYTHNV00200"; //RCMNVYTHNV00100 추천 / RCMNVYTHNV00200 신고
        param.reportValue = vm.insertNewsReport.reportValue;
        if (vm.insertNewsReport.reportValue == "RPTNVYTHNV00400") {
          param.reportEtcValue = vm.insertNewsReport.reportEtcValue;
        }
      }
      Axios.post(url, {youthVo: param}).then(function (response) {
        if (kind == 'like') {
          vm.viewModel.isLike = !vm.viewModel.isLike;
          if (vm.viewModel.reportList.length <= 2) { //신고+추천
            vm.viewModel.reportList.push(param);
          }

          if (vm.viewModel.isLike) {
            vm.viewModel.detail.likeCnt++;
          } else {
            vm.viewModel.detail.likeCnt--;
          }
        } else if (kind == 'report') {
          if (response.data.succCnt > 0) {
            swal("등록되었습니다.").then(result => {
              window.location.reload();
            });
            return false;
          }
        }
      }).catch(function (ex) {
        console.log(ex);
      });
    }
    /*============================================================ 저장 end ========================================================================*/,
    //댓글작성 초기화
    fnClearReply: function () {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyPwd = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
    },
    //댓글작성 레이아웃 출력
    fnShowReplyWrite: function () {
      let vm = this;
      vm.viewModel.isReply = !vm.viewModel.isReply;
      vm.viewModel.isReplyPwd = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;
    },
    //대댓글 작성 레이아웃 출력
    fnShowReReplyWrite: function (key) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyPwd = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = !vm.viewModel.isReReply;
      vm.viewModel.isReReplyUpt = false;
      vm.viewModel.currReplyUidKey = key;
    },
    //댓글 수정/삭제 비밀번호 레이아웃 출력
    fnShowCheckPassword: function (youthVo, flag) {
      let vm = this;
      vm.viewModel.isReply = false;
      vm.viewModel.isReplyUpt = false;
      vm.viewModel.isReReply = false;
      vm.viewModel.isReReplyUpt = false;

      if (youthVo.usrKey == "GUEST") {
        if (vm.viewModel.currReplyUidKey == youthVo.replyUidKey) {
          vm.viewModel.isReplyPwd = !vm.viewModel.isReplyPwd;
        } else {
          vm.viewModel.currReplyUidKey = youthVo.replyUidKey;
          vm.viewModel.replyUptDelFlag = flag;
          vm.viewModel.isReplyPwd = true;
        }
      } else {
        vm.viewModel.currReplyUidKey = youthVo.replyUidKey;
        if (flag == "upt") {
          vm.fnReplySetValue(youthVo);
        } else if (flag == "del") {
          vm.fnDelReply(youthVo.replyUidKey);
        }
      }
    },
    //댓글 수정 값 세팅
    fnReplySetValue: function (youthVo) {
      let vm = this;
      if (youthVo.replyDepth == 0) {
        vm.viewModel.isReplyUpt = true;
        vm.updateNewsReply.replyUidKey = youthVo.replyUidKey;
        vm.updateNewsReply.replyRating = youthVo.replyRating;
        vm.updateNewsReply.replyContent = youthVo.replyContent;
      } else if (youthVo.replyDepth == 1) {
        vm.viewModel.isReReplyUpt = true;
        vm.updateNewsReReply.replyUidKey = youthVo.replyUidKey;
        vm.updateNewsReReply.replyContent = youthVo.replyContent;
      }
    },
    //신고하기 레이아웃 출력
    fnShowReportWrite: function () {
      let vm = this;
      vm.viewModel.isReport = !vm.viewModel.isReport;
    },
    //게시글 수정 값 세팅
    fnYouthSetValue: function (youthVo) {
      let vm = this;
      if (youthVo.replyDepth == 0) {
        vm.viewModel.isReplyUpt = true;
        vm.updateNewsReply.replyUidKey = youthVo.replyUidKey;
        vm.updateNewsReply.replyRating = youthVo.replyRating;
        vm.updateNewsReply.replyContent = youthVo.replyContent;
      } else if (youthVo.replyDepth == 1) {
        vm.viewModel.isReReplyUpt = true;
        vm.updateNewsReReply.replyUidKey = youthVo.replyUidKey;
        vm.updateNewsReReply.replyContent = youthVo.replyContent;
      }
    },
    //페이징 처리
    fnSetPager: function (totalCount, etc) {
      let vm = this;
      vm.viewModel.pager.etc = etc
      vm.viewModel.pager.totalSize = totalCount;
      vm.viewModel.pager.pageNum = (vm.viewModel.pager.pageNo * vm.viewModel.pager.rowSize) - vm.viewModel.pager.rowSize;
      Pager.props = Pager.methods.createPager(vm.viewModel.pager, vm, "list");
    },
    //에디터 이벤트
    onEditorChange: function (event) {
      this.insertNewsModel.content1 = event.html;
      this.$emit('getEditorInfo', event);
    },
    //숫자만 입력
    fnStaffCntBindNumber(event) {
      let value = event.target.value;

      let reg = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣|a-z|!?@#$%^&*():;+-=~{}<>\_\[\]\|\\\"\'\,\.\/\`\\]/;
      if (reg.exec(value) !== null) {
        this.insertNewsModel.staffCnt = value.replace(/[^0-9]/g, '');
      }

      if (isNaN(parseInt(value))) {
        this.insertNewsModel.staffCnt = '';
      } else {
        this.insertNewsModel.staffCnt = parseInt(value);
      }
    },
    //swalalert 호출
    fnOnSwalAlert: function (title, content, callback) {
      let vm = this;
      swal({
        title: title,
        text: content,
        icon: vm.fnOnLoadSwalImageData('info'),
        buttons: true,
        dangerMode: true
      }).then(result => {
        if (result) {
          callback();
        } else {

        }
      });
    },
    //alert 이미지 호출
    fnOnLoadSwalImageData: function (value) {
      let _icon = "/design/common/images/sub/img_alert_" + value + ".png";
      return _icon;
    }
    /*============================================================ 공유 start ========================================================================*/
    /*, fnOnClickSharePopPage:function(param){
        let vm = this;
        let share_uri = '';
        let share_title = '';
        let share_img = '';

        share_uri = 'https://new.youthnavi.net//customer/youth/youthNewsDetail?paramUid=' + $("#paramUid").val();
        share_title = vm.viewModel.detail.title;

        if(vm.viewModel.fileImgList.length > 0){
            share_img = "https://new.youthnavi.net/" + vm.viewModel.fileImgList[0].fileUrl;
        }else{
            share_img = 'https://new.youthnavi.net//design/common/images/sub/img_noimg.png';
        }

        let _url = '/customer/activity/share';
        _url += '?url=' + encodeURIComponent(share_uri);
        _url += '&title=' + encodeURIComponent(share_title);
        _url += '&image=' + encodeURIComponent(share_img);
        window.open(_url, '공유하기', "width=650, height=300, toolbar=no, menubar=no, scrollbars=no, resizable=yes");
    }*/,
    fnOnClickSharePop: function () {
      this.isShare = true;
    },
    fnOnClickCloseSharePop: function () {
      this.isShare = false;
    },
    fnOnLoadKakaoContent: function (value) {
      let _atag = value.replace(/<(\/a|a|\/img|img|\/br|br|\/p|p|\/span|span)([^>]*)>/gi, "");
      if (_atag == null) {
        return '';
      }
      let _nbsptag = _atag.replace(/&nbsp;/gi, "");
      if (_nbsptag == null) {
        return '';
      }
      let _httptag = _nbsptag.replace(/^(((http(s?))\:\/\/))([0-9a-zA-Z\-]+\.)+[a-zA-Z]{2,6}(\:[0-9]+)?(\/\S*)?/, "");
      if (_httptag == null) {
        return '';
      }
      return (_httptag.length >= 200) ? _httptag.substring(0, 200).concat('...') : _httptag;
    },

    fnOnClickKakaoShare: function () {
      let vm = this;
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;

        _uri = urlAddress + '/customer/youth/youthNewsDetail?paramUid=' + $("#paramUid").val() + "&shared=Y";

        vm.fnShareLog($("#paramUid").val());

        if (vm.viewModel.fileImgList.length > 0) {
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateKakaoShareUrl(_uri,
          vm.viewModel.detail.title,
          _imgPath,
          '',
          '',
          '',
          '',
          ''
        );
      });
    },
    fnOnClickNaverShare: function () {
      let vm = this;
      let _uri = '';
      let _imgPath = '';

      let param = {};
      let urlAddress = '';
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;

        _uri = urlAddress + '/customer/youth/youthNewsDetail?paramUid=' + $("#paramUid").val() + "&shared=Y";

        vm.fnShareLog($("#paramUid").val());

        if (vm.viewModel.fileImgList.length > 0) {
          _imgPath = urlAddress + "/" + vm.viewModel.fileImgList[0].fileUrl;
        } else {
          _imgPath = urlAddress + '/design/common/images/sub/img_noimg.png';
        }

        Share.methods.fnOnCreateNaverShareUrl(_uri,
          vm.viewModel.detail.title,
          _imgPath
        );
      });
    },
    fnOnClickFacebookShare: function () {
      let urlAddress = '';
      let param = {};
      Axios.post("/api/url/address", param).then(function (response) {
        urlAddress = response.data.urlName;
        let _uri = urlAddress + '/customer/youth/youthNewsDetail?paramUid=' + $("#paramUid").val() + "&shared=Y";

        vm.fnShareLog($("#paramUid").val());

        Share.methods.fnOnCreateFacebookShareUrl(_uri);
      });
    },
    fnOnClickLinkShare: function () {
      let urlAddress = '';
      let param = {};
      Axios.post("/api/url/address", param).then(function (response) {
        console.log("response.data", response.data);
        urlAddress = response.data.urlName;
        let _uri = urlAddress + '/customer/youth/youthNewsDetail?paramUid=' + $("#paramUid").val() + "&shared=Y";

        vm.fnShareLog($("#paramUid").val());

        let popup_url = '/customer/activity/share/link';
        popup_url += '?url=' + encodeURIComponent(_uri);
        window.open(popup_url, '공유하기', "width=550, height=550, toolbar=no, menubar=no, scrollbars=no, resizable=no");
      });
    },
    fnShareLog(uidKey) {
      Axios.post("/api/logCud/insert", {
        paramUid: uidKey,
        statusCode: "share",
        version: "insert"
      }).then(function (response) {
        let result = response.data.resultCnt;
      });
    }
    /*============================================================ 공유 end ========================================================================*/
  }
});
